import { ILoggedInUserData } from "./authSlice.types";
import { ISessionResponse } from "./authSlice.types";

export const getUserData = (data: ISessionResponse | null): ILoggedInUserData => {
    const userId = data?.authn.user.id;
    const selectedOrg = data?.authn.user.org_selected;

    const groups = data?.authz.user.groups || [];
    const userIsolatedGroupId =
        groups.find((group) => group.name === `drax_executive`)?.id ||
        groups.find((group) => group.name === `user_${userId}`)?.id;

    return {
        userId: data?.authn.user.id || 0,
        name: data?.authn.jwt.given_name || "",
        username: data?.authn.user.username || "",
        lastLoggedInDate: data?.authn.jwt.auth_time || 0,
        groupId: selectedOrg?.group_id || userIsolatedGroupId,
        groups: data?.authz.user.groups || [],
        selectedOrg,
    };
};

export const compoundUserPermissions = (sessionData: ISessionResponse) => {
    const userId = sessionData.authn.user.id;
    const userData = sessionData.authz.user;

    // Selected Org Id and its permissions
    const userSelectedOrgId = sessionData.authn.user.org_selected?.group_id;
    const userOrgData = userData?.group_roles.find((g) => g.id === userSelectedOrgId);

    const userRolesInOrg = userOrgData?.roles_permissions || [];
    const userRoles = userData?.roles_permission || [];

    // Default group role permissions for projects should be drax_executive if exists, if not `user_${userId}`
    const userRolesProjectsFreeTier =
        userData?.group_roles.find((g) => g.name === `drax_executive`)?.roles_permissions ||
        userData?.group_roles.find((g) => g.name === `user_${userId}`)?.roles_permissions ||
        [];

    // If user has a selected org
    if (userOrgData) {
        return [...userRolesInOrg, ...userRoles, ...userRolesProjectsFreeTier];
    }

    // If user doesn't have a selected org use roles_permission
    return [...userRoles, ...userRolesProjectsFreeTier];
};
